<template lang="pug">
fragment
    router-view(:key="$route.fullPath")
    CustomCursor
</template>

<script>
import globalSEO from "@/seo/global";
import CustomCursor from "@/components/cursor/cursor.vue";
export default {
    name: "App",
    metaInfo: globalSEO,
    components: {
        CustomCursor,
    },
};
</script>

<style lang="scss">
@import "@/scss/global/index";
@import "~vue-slick-carousel/dist/vue-slick-carousel.css";
</style>
